import React, { useEffect, useState, useRef } from "react";
import Constants from "../constants/Constants";
const POPUP_CLASS = "show_popup";
const GiveTip = ({ model, setGiveTip, biller }) => {
  const tipOptions = [5, 10, 25, 50, 100, 250];
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedTip, setSelectedTip] = useState(25);
  const [withError, setWithError] = useState(false);
  const [tipSuccess, setTipSuccess] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const polling = useRef(null);
  const closeDownJoin = () => {
    document.body.classList.remove(POPUP_CLASS);
    setTimeout(() => setGiveTip(false), 500);
  };
  const startPolling = (tok, newWindow) => {
    let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
    polling.current = evtSource;

    evtSource.onopen = function() {
      console.log("Checking with the 7 about the new site.");
    };

    evtSource.onmessage = function(e) {
      if (e.data === "SUCCESS!") {
        newWindow.close();
        evtSource.close();
        setIsConfirmed(true);
        setIsProcessing(false);
        setTipSuccess(true);
      } else if (e.data === "STOP!") {
        newWindow.close();
        evtSource.close();
        setErrorText("Your credit card declined the charge.");
        setWithError(true);
        setIsProcessing(false);
        setIsConfirmed(true);
      } else {
        console.log("...");
      }
    };

    evtSource.onerror = function() {
      evtSource.close();
      console.log("joined failed.");
    };
  };
  const makePurchase = (newWindow) => {
    setIsProcessing(true);
    let formData = new FormData();
    formData.append("siteid", model.id);
    formData.append("amount", selectedTip);
    fetch(`${Constants.API}attempt-tip.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          if ("success" in res) {
            setIsConfirmed(true);
            setIsProcessing(false);
            setTipSuccess(true);
          } else {
            const goTo = `https://wnu.com/secure/services/?api=camcharge&action=authandclose&auth_amount=${res.auth_amount}&member_id=${res.member_id}&include_css=${res.include_css}&returnurl=${res.returnurl}&description=${res.x_description}&pburl=${res.pburl}&x_description=${res.x_description}&x_pkey=${res.x_pkey}&x_site=${res.x_site}&epoch_digest=${res.epoch_digest}`;
            newWindow.location = goTo;
            startPolling(res.x_pkey, newWindow);
          }
        } else {
          if (newWindow) {
            newWindow.close();
          }
          setErrorText(res.error);
          setWithError(true);
          setIsProcessing(false);
          setIsConfirmed(true);
        }
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    document.body.classList.add(POPUP_CLASS);
    const letPoll = polling.current;
    return () => {
      if (letPoll) {
        letPoll.close();
      }
      document.body.classList.remove(POPUP_CLASS);
    };
  }, []);
  return (
    <div className="popup">
      <div className="popup_modal">
        <button
          type="button"
          className="popup_close"
          id="popup_close"
          onClick={closeDownJoin}
        >
          <i className="icon-close" />
        </button>
        <div className="avatar">
          <img
            src={`https://addfriends.com/images/sites/${model.site_url}.jpg`}
            alt=""
          />
        </div>

        {tipSuccess ? (
          <div className="content">
            You've Tipped <strong>{model.site_name}</strong> ${selectedTip}{" "}
            Dollars
          </div>
        ) : (
          <div className="content">
            Send <strong></strong> A Tip?{" "}
          </div>
        )}

        <div className="tipAmounts">
          {tipSuccess
            ? null
            : tipOptions.map((tip) => (
                <div
                  className={
                    selectedTip === tip ? "tipAmount active" : "tipAmount"
                  }
                  onClick={() => setSelectedTip(tip)}
                  key={`tip${tip}`}
                >
                  ${tip}
                </div>
              ))}
        </div>
        <div className={isProcessing ? "bottom processing" : "bottom"}>
          <button
            type="button"
            className={
              isConfirmed
                ? withError
                  ? "button buttonChoice confirmed withError"
                  : "button buttonChoice confirmed"
                : "button buttonChoice"
            }
            onClick={() => {
              if (isConfirmed) {
                closeDownJoin();
                return false;
              }
              let newWindow = null;
              if (biller !== 14) {
                newWindow = window.open(
                  "https://addfriends.com/robots-working/",
                  "_blank"
                );
              }

              makePurchase(newWindow);
            }}
          >
            {isProcessing
              ? "Processing..."
              : withError
              ? "FAILED"
              : isConfirmed
              ? "Success!"
              : "Confirm"}
            <div className="nk-spinner" />
            {withError ? (
              <span className="close" />
            ) : (
              <span className="checked" />
            )}
          </button>
          {withError ? <div className="giveError">{errorText}</div> : null}

          <div className="hide_link">
            <a href="https://addfriends.com/contact-us">Contact support</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiveTip;
